function initSonarity(root) {
  root = root || document;

  // Bundles
  root.querySelectorAll("[data-bundle]:not([data-sonarity-bound])").forEach(function (card) {
    card.setAttribute("data-sonarity-bound", "");
    card.addEventListener("click", function () {
      var scope = card.closest(".s-bundles") || root;
      scope.querySelectorAll("[data-bundle]").forEach(function (x) { x.classList.remove("is-active"); });
      card.classList.add("is-active");
      var form = card.closest("form") || root.querySelector("form");
      var input = form ? form.querySelector('input[name="id"]') : root.querySelector('input[name="id"]');
      if (input && card.dataset.variantId) input.value = card.dataset.variantId;
      var priceRow = document.getElementById("s-price-row");
      var priceOld = document.getElementById("s-price-old");
      var priceNew = document.getElementById("s-price-new");
      if (priceRow && priceNew) {
        priceNew.textContent = card.dataset.priceHtml || "";
        if (card.dataset.compareHtml) {
          priceOld.textContent = card.dataset.compareHtml;
          priceRow.style.display = "flex";
        } else {
          priceOld.textContent = "";
          priceRow.style.display = "none";
        }
      }
      var addToCartBtn = document.getElementById("s-add-to-cart-btn");
      if (addToCartBtn && card.dataset.priceHtml) {
        var label = addToCartBtn.dataset.label || "Add to Cart";
        addToCartBtn.textContent = label + " — " + card.dataset.priceHtml;
      }
    });
  });

  // Qty
  root.querySelectorAll("[data-qty-decrease]:not([data-sonarity-bound])").forEach(function (btn) {
    btn.setAttribute("data-sonarity-bound", "");
    btn.addEventListener("click", function () {
      var input = btn.parentElement.querySelector("[data-qty-input]");
      if (input) { input.value = Math.max(0, parseInt(input.value || "0", 10) - 1); autoSubmitCart(); }
    });
  });
  root.querySelectorAll("[data-qty-increase]:not([data-sonarity-bound])").forEach(function (btn) {
    btn.setAttribute("data-sonarity-bound", "");
    btn.addEventListener("click", function () {
      var input = btn.parentElement.querySelector("[data-qty-input]");
      if (input) { input.value = parseInt(input.value || "0", 10) + 1; autoSubmitCart(); }
    });
  });

  // Add to Cart
  var addBtn = root.querySelector("#s-add-to-cart-btn:not([data-sonarity-bound])");
  if (addBtn) {
    addBtn.setAttribute("data-sonarity-bound", "");
    addBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var addForm = addBtn.closest("form");
      var variantInput = addForm ? addForm.querySelector('input[name="id"]') : document.querySelector('#product-form input[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;
      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count > 0) {
            window.location.href = "/cart";
          } else {
            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            })
              .then(function () { openCartModal(); })
              .catch(function (err) { console.error("Shopify add-to-cart failed:", err); window.location.href = "/cart"; });
          }
        })
        .catch(function () { window.location.href = "/cart"; });
    });
  }

  // Modal close
  root.querySelectorAll("[data-modal-close]:not([data-sonarity-bound])").forEach(function (el) {
    el.setAttribute("data-sonarity-bound", "");
    el.addEventListener("click", function () {
      var modal = document.getElementById("s-added-modal");
      if (modal) modal.classList.remove("is-open");
    });
  });

  // Gallery thumbnails
  root.querySelectorAll(".s-thumb:not([data-sonarity-bound])").forEach(function (btn) {
    btn.setAttribute("data-sonarity-bound", "");
    btn.addEventListener("click", function () {
      var mainImg = root.querySelector("[data-gallery-main]");
      if (!mainImg) return;
      mainImg.src = btn.dataset.galleryThumb;
      mainImg.srcset = "";
      var thumbs = (btn.closest(".s-gallery-thumbs") || root).querySelectorAll(".s-thumb");
      thumbs.forEach(function (t) { t.classList.remove("is-active"); });
      btn.classList.add("is-active");
    });
  });
}

// ── Cart Discount Modal ──
function openCartModal() {
  var modal = document.getElementById("s-cart-modal");
  if (!modal) { window.location.href = "/cart"; return; }

  document.getElementById("s-cm-loading").style.display = "";
  document.getElementById("s-cm-applied").style.display = "none";
  modal.classList.add("is-open");

  fetch("/cart.js")
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      setTimeout(function () {
        var item = cart.items && cart.items[0];
        if (item) {
          var labelEl = document.getElementById("s-cm-label");
          if (labelEl) {
            labelEl.textContent = (item.variant_title || item.product_title || "Your item") + " is on its way to checkout.";
          }
          var priceNew = item.final_line_price / 100;
          var compareMap = { "BUY 1 PAIR": 259, "BUY 2 PAIRS": 518 };
          var priceOld = compareMap[item.variant_title] || compareMap[item.title] || (item.compare_at_price ? item.compare_at_price * item.quantity : item.original_line_price) / 100;
          var currency = cart.currency || "USD";
          var fmt = function (v) {
            return v.toLocaleString("en-US", { style: "currency", currency: currency });
          };
          document.getElementById("s-cm-price-new").textContent = fmt(priceNew);
          if (priceOld > priceNew) {
            document.getElementById("s-cm-price-old").textContent = fmt(priceOld);
            var pct = Math.round((1 - priceNew / priceOld) * 100);
            document.getElementById("s-cm-percent").textContent = "🎉 " + pct + "% DISCOUNT APPLIED";
          } else {
            document.getElementById("s-cm-price-old").textContent = "";
            document.getElementById("s-cm-percent").textContent = "";
          }
        }
        document.getElementById("s-cm-loading").style.display = "none";
        document.getElementById("s-cm-applied").style.display = "";
        renderCartConfetti();
      }, 1500);
    })
    .catch(function () {
      setTimeout(function () {
        document.getElementById("s-cm-loading").style.display = "none";
        document.getElementById("s-cm-applied").style.display = "";
      }, 1500);
    });
}

function renderCartConfetti() {
  var container = document.getElementById("s-cm-confetti");
  if (!container) return;
  container.innerHTML = "";
  var colors = ["#3B7891","#6AA8B8","#F4B942","#2E8B70","#fff"];
  for (var i = 0; i < 70; i++) {
    var piece = document.createElement("div");
    piece.className = "s-cm-confetti-piece";
    var angle = Math.random() * Math.PI * 2;
    var burst = 80 + Math.random() * 120;
    var bx = Math.cos(angle) * burst;
    var by = Math.sin(angle) * burst - 40;
    var size = 5 + Math.random() * 8;
    piece.style.width = size + "px";
    piece.style.height = size + "px";
    piece.style.background = colors[i % colors.length];
    piece.style.borderRadius = i % 3 === 0 ? "50%" : "2px";
    piece.style.setProperty("--bx", bx + "px");
    piece.style.setProperty("--by", by + "px");
    piece.style.setProperty("--fall", (150 + Math.random() * 150) + "px");
    piece.style.animation = "s-cm-confetti-burst " + (1.2 + Math.random() * 1) + "s cubic-bezier(.15,.7,.3,1) " + (Math.random() * 0.2) + "s forwards";
    container.appendChild(piece);
  }
}

function closeCartModal() {
  var modal = document.getElementById("s-cart-modal");
  if (modal) modal.classList.remove("is-open");
}

var s_cartSubmitTimer = null;
function autoSubmitCart() {
  clearTimeout(s_cartSubmitTimer);
  s_cartSubmitTimer = setTimeout(function () {
    var form = document.getElementById("cart-form");
    if (form) form.submit();
  }, 500);
}

function renderConfetti() {
  var container = document.getElementById("s-confetti");
  if (!container) return;
  container.innerHTML = "";
  var colors = ["#3B7891", "#6AA8B8", "#F4B942", "#2E8B70"];
  for (var i = 0; i < 60; i++) {
    var piece = document.createElement("div");
    piece.className = "s-confetti-piece";
    var angle = Math.random() * Math.PI * 2;
    var burst = 60 + Math.random() * 90;
    var bx = Math.cos(angle) * burst;
    var by = Math.sin(angle) * burst - 30;
    var size = 6 + Math.random() * 9;
    var shape = i % 4 === 0 ? "50%" : "2px";
    piece.style.width = size + "px";
    piece.style.height = size + "px";
    piece.style.background = colors[i % colors.length];
    piece.style.borderRadius = shape;
    piece.style.setProperty("--bx", bx + "px");
    piece.style.setProperty("--by", by + "px");
    piece.style.setProperty("--fall", (180 + Math.random() * 160) + "px");
    piece.style.animation = "s-confetti-burst " + (1.1 + Math.random() * 1.1) + "s cubic-bezier(.15,.7,.3,1) " + (Math.random() * 0.15) + "s forwards";
    container.appendChild(piece);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initSonarity(document);

  // Botão Continue to Checkout no modal
  var checkoutBtn = document.getElementById("s-cm-checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = "/checkout";
    });
  }

  // Fechar modal
  var closeBtn = document.getElementById("s-cm-close");
  if (closeBtn) closeBtn.addEventListener("click", closeCartModal);
  var backdrop = document.getElementById("s-cm-backdrop");
  if (backdrop) backdrop.addEventListener("click", closeCartModal);
});

document.addEventListener("shopify:section:load", function (event) {
  initSonarity(event.target);
});
(function(){
  var el=document.getElementById('s-cart-countdown');
  if(!el)return;
  var t=15*60;
  setInterval(function(){
    if(t<=0){el.textContent='00:00';return;}
    t--;
    var m=Math.floor(t/60),s=t%60;
    el.textContent=(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
  },1000);
})();

